import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import ErrorBoundary from 'components/ErrorBoundary';


let tableDataBackup = [
    {
        chainPharmacy: "123445",
        pharmacy: "123445",
        npi: "123445",
        ncpdPandNABP: "123445",
        pharmacyAddress: "123445",
        pharmacyLiveDate: "123445",
        pharmacyTerminationDate: "123445",
        claimsProcessDate: "123445",
    }
];

const HistoricaldetailsTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    debugger;

    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    console.log(data)
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };


    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    let mainCol = [
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.accountType),
        },
        {
            dataField: 'invoicedDate',
            text: 'Invoiced Date',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => dateFormate(row.invoicedDate),
        },
        {
            dataField: 'wholesaler',
            text: 'Wholesaler',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.wholesaler),
        },
        {
            dataField: 'poid',
            text: 'POID',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.poid),
        },
        {
            dataField: 'invoicedQty',
            text: 'Invoiced Qty',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.invoicedQty),
        },
        {
            dataField: 'pkgPrice',
            text: 'Pkg Price',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.pkgPrice),
        },
        {
            dataField: 'totalPrice',
            text: 'Total Price',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.totalPrice),

        },
    ];

    return (
        <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'
            fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
        >
            <ErrorBoundary>
                <ReactStrapTable
                    id='ndc-historical-table'
                    height={550}
                    loading={loading}
                    
                    fixedColumn
                    hidefilter={true}
                    width={1200}
                    reset={reset}
                    data={data}
                    columns={mainCol}
                    //onExport={onExport}
                    filters={colFilter}
                    totalRecords={totalSize}
                   // pageSize={colFilter.pageSize}
                    currentPage={colFilter.currentPage}
                    handleSort={handleSort}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onPageSizeChange}
                    onFilterCancel={handleFilterCancel}
                    onSearchColumnFilters={handleSearchColumnFilters}
                  
                />
            </ErrorBoundary>
        </div>




    );
}

export default HistoricaldetailsTable
